import { ABUSE_DOMAIN } from '../const/domains'

export type ComponentAttributesStoreState = {
  id: string
  domain: string
  autoplay: boolean
  playbackRate: number
  width: string
  height: string
  primaryColor: string
  buttonsColor: string
  buttonsHoverColor: string
  progressBarColor: string
  playButtonColor: string
  titleColor: string
  overlayTextColor: string
  overlayBackgroundTopColor: string
  overlayBackgroundBottomColor: string
  muted: boolean
  volume: number
  hideControls: boolean
  hideTitle: boolean
  hidePoster: boolean
  loop: boolean
  forceMobileLayout: boolean
  mediaTitle: string
  showCaptions: boolean
  disableHotkeys: boolean
  disableDownload: boolean
  sequenceStart: number
  sequenceEnd: number
  disableQualityPicker: boolean
  maxQuality: number
  forcedQualityLevel: number
  uiLanguage: string
  collectorDomain: string
  abuseDomain: string
}

const defaults: ComponentAttributesStoreState = {
  id: '',
  domain: '',
  autoplay: false,
  playbackRate: 1,
  width: '',
  height: '',
  primaryColor: '',
  buttonsColor: '',
  buttonsHoverColor: '',
  progressBarColor: '',
  playButtonColor: '',
  titleColor: '',
  overlayTextColor: '',
  overlayBackgroundTopColor: '',
  overlayBackgroundBottomColor: '',
  muted: false,
  volume: 1,
  hideControls: false,
  hideTitle: false,
  hidePoster: false,
  loop: false,
  forceMobileLayout: false,
  mediaTitle: '',
  showCaptions: false,
  disableHotkeys: false,
  disableDownload: false,
  sequenceStart: 0,
  sequenceEnd: 0,
  disableQualityPicker: false,
  maxQuality: 0,
  forcedQualityLevel: 0,
  uiLanguage: navigator.language || (navigator as any).userLanguage || 'en',
  collectorDomain: '',
  abuseDomain: ABUSE_DOMAIN,
}

const state: ComponentAttributesStoreState = $state({ ...defaults })

export default {
  state,
  defaults,
}
